import './AddFantasyDialog.scss';


import {FantasyRateRow, FantasyInfo, FantasyStatus} from "./types";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import Select from "../1. Core/Controls/Select/Select";
import NumField from "../1. Core/Controls/TextField/NumField";
import Delegate from "../1. Core/Delegate";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {EventTournament, SportType} from "../10. Battle/types";
import {getTournaments, ITournament} from "../10. Battle/Util";

let moment = require('moment');

export default class AddFantasyDialog extends Dialog {
    private _tournamentCombo: IconSelect;
    private _selectEventBtn: Select;
    private _athletesNode: HTMLElement;
    private _athleteInputs: NumField[][];
    private _FantasyId: number;
    private EvChanged: Delegate;
    private _statusCombo: Select;


    _initFields(settings: object) {
        this.EvChanged = new Delegate();
        this._FantasyId = null;
        super._initFields(settings);
        this._Mode = 'FullHeight';
        this._Caption = 'Fantasy';
        this._ShowHeader = true;
        this._Width = 600;
        this._ShowCloseButton = true;
        this._OkRK = 'Save'
    }

    formatDate(d: string) {
        return moment(d, 'YYYY-MM-DD HH:mm:ss.S').format('YYYY-MM-DD')
    }

    _render() {
        super._render();
        this.addClass('add-fantasy-dialog')


        this._statusCombo = new Select({
            FloatingLabel: "Status",
            ParentNode: this._contentNode,
            Items: [
                {Content: 'Open', Value: FantasyStatus.Open},
                {Content: 'Closed', Value: FantasyStatus.Closed},
                {Content: 'Calculated', Value: FantasyStatus.Calculated}]
        });

        this._tournamentCombo = new Select({
            ParentNode: this._contentNode,
            FloatingLabel: NP.RM.getString('Tournament'),
            EvItemSelected: async () => {
                let response = await ServerAPI.post("/t-events", {
                    TournamentId: this._tournamentCombo.getValue(),
                    Count: 500,
                    CalcCount: true
                }) as { List: EventTournament[] };

                this._selectEventBtn.setItems(response.List
                    .filter(it => it.BattleCount > 0)
                    .map(item => Object.assign({Content: `${item.Name} ${this.formatDate(item.Date)}`, Value: item})));
            }
        });


        this._selectEventBtn = new Select({
            FloatingLabel: NP.RM.getString('EventName'),
            ParentNode: this._contentNode,
            EvItemSelected: () => this.refreshAthleteList()
        });


        this._athletesNode = NP.createNode(this._contentNode, 'fantasy-dlg-athlete-list');
        this._athleteInputs = [];

        this.refresh();
    }

    async refresh() {


        if (this._FantasyId) {
            this._tournamentCombo.setEnabled(false);
            this._selectEventBtn.setEnabled(false);
            let finfo = await ServerAPI.get(`/fantasy/${this._FantasyId}`) as FantasyInfo;
            let tEvent = await ServerAPI.get(`/t-events/${finfo.EventId}`) as EventTournament;

            this.updateAthletePoints(finfo.Points);
            this._tournamentCombo.setItems([{Content: finfo.TournamentName}]);
            this._tournamentCombo.setSelectedIndex(0, false);

            this._selectEventBtn.setItems([{Content: finfo.EventName, Value: tEvent}]);
            this._selectEventBtn.setValue(tEvent, false);

            this._statusCombo.setValue(finfo.Status)
        } else {
            let tournaments = await getTournaments(SportType.MMA) as ITournament[];
            let items = tournaments.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
            this._tournamentCombo.addItems(items);
            this._tournamentCombo.setSelectedIndex(0, true);
        }
    }

    async refreshAthleteList() {
        this._athleteInputs.forEach(item => this._destroyArray(item))
        this._athleteInputs = [];

        this._athletesNode.innerHTML = '';
        if (this._selectEventBtn.getValue()) {
            let res = await ServerAPI.callUiApi(`/fantasy/getAthletesFromEvent/${this._selectEventBtn.getValue().Id}`) as FantasyRateRow[];
            this.updateAthletePoints(res);
        }
    }

    updateAthletePoints(items: FantasyRateRow[]) {
        items = items.sort((a: FantasyRateRow, b: FantasyRateRow) => a.BattleId - b.BattleId)

        for (let i = 0; i < items.length - 1; i += 2) {
            this._athleteInputs.push([new NumField({
                FloatingLabel: items[i].FirstName + ' ' + items[i].LastName,
                ParentNode: this._athletesNode,
                Data: items[i],
                Width: 100,
                Min: 10,
                Max: 50,
                Value: items[i].Points,
                EvChanged: new Delegate(this.onPointChanged, this)
            }), new NumField({
                FloatingLabel: 'Odd',
                ParentNode: this._athletesNode,
                Data: items[i],
                Width: 100,
                Min: -10000,
                Max: 10000,
                Value: items[i].Odd || 0,
                EvChanged: new Delegate(this.onOddChanged, this)
            }), new NumField({
                FloatingLabel: items[i + 1].FirstName + ' ' + items[i + 1].LastName,
                ParentNode: this._athletesNode,
                Data: items[i + 1],
                Width: 100,
                Min: 10,
                Max: 50,
                Value: items[i + 1].Points,
                Class: 'right-points-input',
                EvChanged: new Delegate(this.onPointChanged, this)
            }), new NumField({
                FloatingLabel: 'Odd',
                ParentNode: this._athletesNode,
                Data: items[i + 1],
                Width: 100,
                Min: -10000,
                Max: 10000,
                Value: items[i + 1].Odd  || 0,
                Class: 'right-points-input',
                EvChanged: new Delegate(this.onOddChanged, this)
            })]);

            this._br(this._athletesNode);
        }
    }


    onPointChanged(inp: NumField) {
        let arr = this._athleteInputs.find(arr => arr[0] == inp || arr[2] == inp);
        let otherInp = arr[0] == inp ? arr[2] : arr[0];
        let fixedValue = Math.round(inp.getValue() / 10) * 10;
        inp.setValue(fixedValue);
        otherInp.setValue(60 - fixedValue);
    }

    onOddChanged(inp: NumField) {

    }

    async _onOkButtonClick() {
        if (!this._FantasyId && !this._selectEventBtn.getValue())
            return;

        let points = [];

        for (let row of this._athleteInputs) {
            let inp1 = row[0]
            let odd1 = row[1]
            let inp2 = row[2]
            let odd2 = row[3]

            points.push({
                AthleteId: inp1.getData().AthleteId,
                Points: inp1.getValue(),
                BattleId: inp1.getData().BattleId,
                Odd: odd1.getValue()
            })

            points.push({
                AthleteId: inp2.getData().AthleteId,
                Points: inp2.getValue(),
                BattleId: inp2.getData().BattleId,
                Odd: odd2.getValue()
            })
        }

        let fantasyInfo = {
            Id: this._FantasyId,
            EventId: this._selectEventBtn.getValue().Id,
            Status: this._statusCombo.getValue(),
            Points: points
        } as FantasyInfo;


        if (this._FantasyId)
            await ServerAPI.post(`/fantasy/${this._FantasyId}`, fantasyInfo);
        else
            await ServerAPI.post("/fantasy", fantasyInfo);

        this.EvChanged.fire(this);

        this.hide();
    }
}
